export class ExpiredOrganizationData {
    public expiredOrganizations: ExpiredOrganization[];
    public expiringOrganizations: ExpiredOrganization[];
}

class ExpiredOrganization {
    public id: number;
    public name: string;
    public expirationDate: Date;
}


// WEBPACK FOOTER //
// ./src/models/ExpiredOrganizationData.tsx